export interface CategoryItem {
  key: string;
  name: string;
  shortName: string;
  description: string;
  icon: string;
  image: string;
}

export const categories: CategoryItem[] = [
  {
    key: "drama",
    name: "伦理电视剧",
    shortName: "电视剧",
    description: "以连续剧形式展开的伦理剧情作品，注重人物关系的长期铺陈与情感积累，适合沉浸式追看。",
    icon: "ri-tv-2-line",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20moody%20image%20of%20an%20old%20television%20set%20glowing%20warm%20amber%20in%20a%20dark%20room%2C%20deep%20navy%20shadows%2C%20atmospheric%20film%20still%20aesthetic%2C%20subtle%20grain%2C%20muted%20palette%2C%20minimal%20elegant%20composition%2C%20high%20detail&width=800&height=600&seq=jpeth-cat-drama&orientation=landscape",
  },
  {
    key: "movie",
    name: "伦理电影",
    shortName: "电影",
    description: "以电影长片形式呈现的伦理题材，叙事凝练、影像讲究，适合一次完整的沉浸体验。",
    icon: "ri-film-line",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20moody%20image%20of%20a%20vintage%20film%20projector%20beam%20cutting%20through%20a%20dark%20theater%2C%20warm%20amber%20light%20against%20deep%20navy%20shadows%2C%20atmospheric%20film%20still%20aesthetic%2C%20subtle%20grain%2C%20muted%20palette%2C%20elegant%20composition%2C%20high%20detail&width=800&height=600&seq=jpeth-cat-movie&orientation=landscape",
  },
  {
    key: "classic",
    name: "经典回顾",
    shortName: "经典",
    description: "历经时间考验的伦理影视经典，情感真挚、影响深远，是了解这一类型绕不开的必看之作。",
    icon: "ri-history-line",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20moody%20image%20of%20a%20stack%20of%20old%20film%20reels%20and%20photographs%20on%20a%20wooden%20table%2C%20warm%20amber%20lamp%20glow%20and%20deep%20navy%20shadows%2C%20nostalgic%20film%20still%20aesthetic%2C%20subtle%20grain%2C%20muted%20palette%2C%20high%20detail&width=800&height=600&seq=jpeth-cat-classic&orientation=landscape",
  },
  {
    key: "latest",
    name: "最新上映",
    shortName: "最新",
    description: "近期上映或上线的全新伦理剧情作品，紧跟当下话题与创作趋势，第一时间掌握新片动态。",
    icon: "ri-movie-2-line",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20moody%20image%20of%20a%20modern%20cinema%20marquee%20glowing%20warm%20amber%20at%20night%20with%20deep%20navy%20sky%2C%20contemporary%20atmospheric%20film%20still%20aesthetic%2C%20subtle%20grain%2C%20muted%20palette%2C%20minimal%20composition%2C%20high%20detail&width=800&height=600&seq=jpeth-cat-latest&orientation=landscape",
  },
];